import { ImageVariantMap } from '@apparel/ui/images/Image/ImageProps';
import { separate } from '@packages/strings';
import { each } from 'lodash';
import { createPlaceholder } from './createPlaceholder';
import { FileObject, ImageObject } from './types';

/**
 *
 * @param src
 * @param variant
 * @param isPlaceholder
 * @returns {[null, boolean]|[(string|ImageObject), boolean]|[*, boolean]}
 */
export const getImageSource = (
    src: string | FileObject | ImageObject,
    variant = 'original',
    isPlaceholder = false,
): [string | null, boolean] => {
    let $src: any = src || null;
    let objectCreated = false;

    if (src) {
        if (typeof src === 'object') {
            if (src instanceof File) {
                if (!src.source) {
                    src.source = URL.createObjectURL(src);
                    objectCreated = true;
                }

                $src = src.source;
            } else {
                each(separate(ImageVariantMap[variant], ','), (val) => {
                    // $FlowFixMe
                    if (src[val]) {
                        $src = src[val];
                        return false;
                    }
                });
            }
        }
    }

    if (isPlaceholder) {
        $src = createPlaceholder($src);
    }

    return [$src, objectCreated];
};
